import type {
  AdminBusinessInvoice,
  AfriexCurrencyCode,
  BusinessInvoiceListParams,
  BusinessInvoiceStatus,
} from '@/types';

export type InvoiceListProps = {
  error: unknown;
  isLoading: boolean;
  list: AdminBusinessInvoice[];
  pageInfo: {total: number; page: number};
  fetchList: (params: BusinessInvoiceListParams) => void;
  refetchCurrentPage: () => Promise<void>;
  displayPage: number;
  isPageReset: boolean;
  filterCount: number;
  filtersToApply: BusinessInvoiceListParams;
  clearFilters: () => void;
  selectAppliedFilters: (
    name: string,
    value: string | Date | undefined,
  ) => void;
  handleApplyFilters: () => void;
};

export type MerchantOption = {
  key: string;
  value: string;
};

/**
 * The create form's working state. Dates are held as `Date` because the pickers
 * speak Date; they become ISO strings at submit.
 */
export type InvoiceDraft = {
  businessId: string;
  description: string;
  amount: number | '';
  currency: AfriexCurrencyCode | '';
  periodStart?: Date;
  periodEnd?: Date;
  dueDate?: Date;
  settlementAccountId: string;
};

export enum InvoiceActionType {
  UPDATE_INVOICE = 'UPDATE_INVOICE',
  RESET_INVOICE = 'RESET_INVOICE',
}

/** The status modal's working state. */
export type InvoiceStatusDraft = {
  status?: BusinessInvoiceStatus;
  amountPaid: number | '';
  note: string;
};

export enum InvoiceStatusActionType {
  UPDATE_INVOICE_STATUS = 'UPDATE_INVOICE_STATUS',
  RESET_INVOICE_STATUS = 'RESET_INVOICE_STATUS',
}
